<dialog
  #actionDialog
  qai-dialog
  [description]="''"
  [heading]="modalTitle"
  (afterClose)="handleCloseClick()"
>
  <qai-field
    [label]="
      entityType === 'assignment' ? 'Assignment name *' : 'Simulation name *'
    "
    [description]="'This name can be changed later'"
    [error]="errorMessage"
  >
    <input
      qai-input
      type="text"
      [(ngModel)]="inputName"
      (input)="onInputChange()"
    />
  </qai-field>

  <qai-field
    *ngIf="entityType === EntityType.SIMULATION"
    [label]="'Product'"
    class="product-field"
  >
    <qai-floating-select
      [options]="moduleOptions"
      [placeholder]="'Select a product'"
      [placement]="'below-start'"
      [offset]="4"
      [shape]="'rectangle'"
      [value]="selectedModuleUuid"
      [searchable]="true"
      [showActionButton]="true"
      actionButtonLabel="Add new product"
      [disabled]="networkRequestInProgress || isLoadingModuleOptions"
      (action)="onAddNewProduct($event)"
      (selectionChange)="onModuleSelectionChange($event?.value)"
    ></qai-floating-select>
  </qai-field>

  <div class="action-button-container">
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="networkRequestInProgress || !inputName.trim() || (entityType === EntityType.SIMULATION && !selectedModuleUuid)"
      (click)="handleConfirmClick()"
    >
      {{
        entityActionType === EntityActionType.DUPLICATE
          ? 'Duplicate'
          : 'Create'
      }}
      {{
        entityType === EntityType.ASSIGNMENT ? ' assignment' : ' simulation'
      }}
    </button>
  </div>
</dialog>
